const AILabel = ({ active = false, isInteractive = false }) => {
  if (active && isInteractive)
    return (
      <span
        style={{
          backgroundColor: '#ECF7FF',
          padding: '0 0.5rem',
          borderRadius: '3px',
          height: '22px',
          display: 'grid',
          placeItems: 'center',
          width: 'fit-content',
        }}
      >
        <p
          style={{
            color: '#0494FD',
            fontWeight: '600',
            fontSize: '0.75rem',
            lineHeight: '10px',
            height: '10px',
            textWrap: 'nowrap',
          }}
        >
          AI
        </p>
      </span>
    );
  return null;
};

export default AILabel;
